export default __webpack_public_path__ + "static/media/019-roast chicken.6f1285d7.svg";